function SpriteSheet(image, frameWidth, frameHeight) {
  this.image = image;
  this.frameWidth = frameWidth;
  this.frameHeight = frameHeight;
  this.framesPerRow = Math.floor(this.image.width / this.frameWidth);
}

function getDefaultFrameSequence(image, frameWidth, frameHeight) {
  let quantity = Math.floor(image.width / frameWidth) * Math.floor(image.height / frameHeight);
  let frameSequence = [];
  for (var i = 0; i < quantity; i++) {
    frameSequence.push(i);
  }

  return frameSequence;
}

function SpriteAnimation({
  image,
  width,
  height,
  animationSpeed: speed = 1,
  scale = 1,
  frameSequence = getDefaultFrameSequence(image, width, height)
}) {
  const spritesheet = new SpriteSheet(image, width, height);
  let currentFrame = 0;

  this.nextFrame = (animSpeed = speed) => {
    if(animSpeed < 0) {
      currentFrame = (Math.abs(currentFrame + animSpeed));
      currentFrame = currentFrame > 1? currentFrame : frameSequence.length - 1;
      return;
    }
    currentFrame = (currentFrame + animSpeed) % frameSequence.length;
  };

  this.getFrame = () => {
    const frameIndex = Math.floor(currentFrame);
    const row = Math.floor(frameSequence[frameIndex] / spritesheet.framesPerRow);
    const col = Math.floor(frameSequence[frameIndex] % spritesheet.framesPerRow);

    return ({
      image: image,
      sx: col * spritesheet.frameWidth,
      sy: row * spritesheet.frameHeight,
      sWidth: spritesheet.frameWidth,
      sHeight: spritesheet.frameHeight,
      dWidth: spritesheet.frameWidth * scale,
      dHeight: spritesheet.frameHeight * scale
    });
  };
}

export default SpriteAnimation;